export default __webpack_public_path__ + "static/media/dummy.f668af94.png";